import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/buttons/Button';
import { isCapacitor } from '../utils/platform';
import './Subscription.css';

function SubscriptionCancel() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/auth?sub=cancel', { replace: true });
  }, []);

  return null;
}

export default SubscriptionCancel;